import { render } from "./New.vue?vue&type=template&id=5e78dcf2&scoped=true&ts=true&lang=html"
import script from "./New.vue?vue&type=script&lang=ts"
export * from "./New.vue?vue&type=script&lang=ts"

import "./New.vue?vue&type=style&index=0&id=5e78dcf2&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e78dcf2"]])

export default __exports__